export default __webpack_public_path__ + "static/shabanov-309c6601c5e0d569cd5168d60a9ea677.png";